import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import DpaSellOrRefinance from "@/pages/tools/DpaSellOrRefinance";

export const Route = createFileRoute("/tools/dpa-sell-or-refinance")({
  head: () => seoHead("/tools/dpa-sell-or-refinance"),
  component: DpaSellOrRefinance,
});
